import { Facebook, Instagram, Link2 } from "lucide-react";
import { toast } from "sonner";
import { BACKEND_URL } from "../lib/api";
import { useLang } from "./LangContext";
import { STR } from "../lib/i18n";

export default function ShareButtons({ post }) {
  const { lang } = useLang();
  const t = STR[lang].share;
  const shareUrl = `${BACKEND_URL}/api/og/${post.slug}`;
  const caption = post.caption || post.excerpt || post.title;

  const shareFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      "_blank",
      "width=640,height=560"
    );
  };

  const shareInstagram = async () => {
    try {
      await navigator.clipboard.writeText(`${caption}\n\n${shareUrl}`);
      toast.success(t.copiedCaption);
    } catch {
      toast.error(t.copyFail);
    }
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success(t.copiedLink);
    } catch {
      toast.error(t.copyFail);
    }
  };

  return (
    <div data-testid="share-section" className="flex flex-wrap items-center gap-4">
      <span className="overline-label text-[#7B8A80]">{t.label}</span>
      <button
        onClick={shareFacebook}
        data-testid="share-facebook-button"
        className="flex items-center gap-2 rounded-full border border-[#2D4032] px-5 py-2.5 text-sm font-medium text-[#2D4032] transition-colors duration-300 hover:bg-[#2D4032] hover:text-[#F6F5F0]"
      >
        <Facebook className="h-4 w-4" strokeWidth={1.5} />
        Facebook
      </button>
      <button
        onClick={shareInstagram}
        data-testid="share-instagram-button"
        className="flex items-center gap-2 rounded-full border border-[#9E643E] px-5 py-2.5 text-sm font-medium text-[#9E643E] transition-colors duration-300 hover:bg-[#9E643E] hover:text-[#F6F5F0]"
      >
        <Instagram className="h-4 w-4" strokeWidth={1.5} />
        {t.instagram}
      </button>
      <button
        onClick={copyLink}
        data-testid="share-copy-link-button"
        className="flex items-center gap-2 rounded-full border border-[#D8D3C4] px-5 py-2.5 text-sm font-medium text-[#7B8A80] transition-colors duration-300 hover:border-[#2D4032] hover:text-[#2D4032]"
      >
        <Link2 className="h-4 w-4" strokeWidth={1.5} />
        {t.copyLink}
      </button>
    </div>
  );
}
